import React, { createContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
// Lottie
import Lottie from 'lottie-react'
import formSubmission2 from '../../../../assets/lottie/formSubmission2.json'
// MUI Imports
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import Stepper from '@mui/material/Stepper'
import Typography from '@mui/material/Typography'
import LinearProgress from '@mui/material/LinearProgress'
// Tabs
import ReportIncidentIntro from './ReportIncidentIntro'
import Step1 from './ReportIncidentStep1'
import Step2 from './ReportIncidentStep2'
import Step3 from './ReportIncidentStep3'
import Step4 from './ReportIncidentStep4'
import Step5 from './ReportIncidentStep5'
import Step6 from './ReportIncidentStep6'
import Step7 from './ReportIncidentStep7'
import Step8 from './ReportIncidentStep8'

export const IncidentContext = createContext({})

const STEP_LABELS = [
  'Guidance',
  'Details',
  'Description',
  'People',
  'Vehicles',
  'Equipment',
  'Medicines',
  'Attachments',
  'Submit',
]

const ReportIncident = () => {
  const [tab, setTab] = useState(0)
  const [formValues, setFormValues] = useState({})
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const isNumberedStep = typeof tab === 'number'

  return (
    <IncidentContext.Provider value={{ formValues, setFormValues, setTab }}>
      <Box display="flex" flexDirection="column" gap={1.5}>
        <Box>
          <Typography variant="title2">Report an Incident</Typography>
          <Typography variant="caption" color="text.secondary">
            All staff can report incidents. Report as soon as you can — ideally
            within 24 hours, while details are fresh.
          </Typography>
        </Box>
        {isNumberedStep && (
          <Paper
            elevation={0}
            sx={{
              p: 1.5,
              borderRadius: 2.5,
              border: (t) => `1px solid ${t.palette.divider}`,
              overflowX: 'auto',
            }}
          >
            <Stepper
              activeStep={tab}
              alternativeLabel
              sx={{
                minWidth: 640,
                '& .MuiStepLabel-label': { fontSize: '0.72rem', mt: 0.5 },
              }}
            >
              {STEP_LABELS.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </Paper>
        )}
        {loading && <LinearProgress />}
        <Paper
          sx={{
            p: { xs: 2, md: 3 },
            borderRadius: 3,
          }}
        >
          {tab === 0 && <ReportIncidentIntro setTab={setTab} />}
          {tab === 1 && <Step1 />}
          {tab === 2 && <Step2 />}
          {tab === 3 && <Step3 />}
          {tab === 4 && <Step4 />}
          {tab === 5 && <Step5 />}
          {tab === 6 && <Step6 />}
          {tab === 7 && <Step7 setLoading={setLoading} />}
          {tab === 8 && <Step8 />}
          {tab === 'submitted' && (
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              gap={1}
            >
              <Box maxWidth={300} maxHeight="60vh">
                <Lottie animationData={formSubmission2} loop={true} />
              </Box>
              <Typography variant="title3">
                Incident successfully reported.
              </Typography>
              <Typography variant="body2" color="text.secondary" textAlign="center">
                Thank you — the governance team has been notified and will
                review your report.
              </Typography>
              <Button
                onClick={() => navigate('/')}
                color="primary"
                variant="contained"
              >
                Return to Dashboard
              </Button>
            </Box>
          )}
        </Paper>
      </Box>
    </IncidentContext.Provider>
  )
}

export default ReportIncident
